import React from 'react';

interface ScoreBadgeProps {
  // The member's score for a course, 0 to 100. Null or undefined while the course is unranked or
  // the member has ranked fewer than 5 courses, which shows a dash.
  score?: number | null;
}

// The gold ring with the member's score for a course, on the ranking list and the ranking flow's
// result. The ring is the gold (a rule, never text on a light ground, per BRAND.md); the number is
// ink.
const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score }) => (
  <span
    // Smaller on a phone, where the ranking table has to fit the switch beside it without a
    // sideways scroll.
    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-primary text-[11px] font-semibold tabular-nums text-ink dark:text-white sm:h-11 sm:w-11 sm:text-sm"
    aria-label={score != null ? `Score ${score}` : 'No score yet'}
  >
    {score != null ? score.toLocaleString('en-US') : '-'}
  </span>
);

export default ScoreBadge;
